import { Typography } from "@mui/material";
import { ERROR_COLOR } from "@/constants";

interface FormLabelProps {
  label: string;
  required?: boolean;
}

export function FormLabel({ label, required = false }: FormLabelProps) {
  return (
    <Typography
      variant="overline"
      sx={{
        fontWeight: 700,
        color: "text.secondary",
        mb: 0.5,
        display: "block",
      }}
    >
      {label} {required && <span style={{ color: ERROR_COLOR }}>*</span>}
    </Typography>
  );
}
